import React, {useState,useEffect} from "react"
import { View } from "react-native";
import InsuranceOptions from "./InsuranceOptions";
import Benifits from "./Benifits";
import PersonalDetails from './PersonalDetails'
import NomineeDetails from './NomineeDetails'
import VehicleSelectionForDebit from "./Hamburger/VehicleSelectionForDebit";
import CancelTripInsurance from "./CancelTripInsurance";
import TripTransactionHistory from "./TripTransactionHistory";
import TiInsuranceCertificate from "./TiInsuranceCertificate";
import TripDisputeHome from "./TripDisputeHome";
import TripRaiseDispueTransactions from "./TripRaiseDisputeTransactions";
import TripCreateRaiseDispute from "./TripCreateRaiseDispute";
import PaymentBreakup from "../Profile/PaymentBreakup";
import { useOutletContext } from "react-router-dom";

export default function Index (props){
    const {state} = useOutletContext()
    const useCase = state?.useCase || ""
    console.log(useOutletContext(),state," useOutletContext()")
    const [activeScreen, setActiveScreen] = useState("");
    const [data,setData] = useState({})
    const [selectedLayout, setSelectedLayout] = useState("")

    useEffect(() => {
        if(state?.activeScrren == "Benifits") {
                setActiveScreen("Benifits")
                setData({addVehicleData: state?.addVehicleData})
            }
        else{setActiveScreen("Home")}
   
    },[state?.activeScrren])

    function renderSwitch() {
        switch(activeScreen) {
            case 'PriceBreakup':
                return <PaymentBreakup setScreen={setActiveScreen} setData={setData} data={data}
                    info={{
                        backNavigation: data?.insuranceSkipped ? "Benifits" : 'NomineeDetails',
                    }}
                />
            case 'home' :
                return <InsuranceOptions   setScreen = {setActiveScreen} setData={setData} data={data} />
        case 'Benifits' : 
                return <Benifits  setScreen={setActiveScreen} setData={setData} data={data}
                info={ useCase !== "Add-Vehicle"?{
                    useCase: 'Hamburger-Menu',
                    backNavigation: 'home',
                    showSkipButton:false
                } :{
                    useCase: 'Add-Vehicle',
                    backNavigation: 'addVehicle',
                    showSkipButton:true,
                    skipNavigation:"PriceBreakup"
                } }/>;
        case 'personalDetails' : 
                return <PersonalDetails  setScreen = {setActiveScreen} setData={setData} data={data}/>
        case 'NomineeDetails' : 
                return useCase == "Add-Vehicle" ? (
                  <NomineeDetails
                    setScreen={setActiveScreen}
                    setData={setData}
                    data={data}
                    info={{
                      proceedNavigation: "addVehicle",
                      skipNavigation: "PriceBreakup",
                      backNavigation: "personalDetails",
                    }}
                    setActiveUserScreen={"Payment Breakup"}
                    activeUserScreen={(layout) => setSelectedLayout(layout)}
                  />
                ) : (
                  <NomineeDetails
                    setScreen={setActiveScreen}
                    setData={setData}
                    data={data}
                    info={{
                      proceedNavigation: "SelectVehicle",
                      skipNavigation: "SelectVehicle",
                    }}
                  />
                );
        case 'SelectVehicle' : 
                return <VehicleSelectionForDebit  setScreen = {setActiveScreen} setData={setData} data={data}/>
        case 'CancelPolicy' : 
                return <CancelTripInsurance  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'home',
                }}
                />
        case 'TransactionHistory' : 
                return <TripTransactionHistory  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'home',
                }}
                />
        case 'Certificate' : 
                return <TiInsuranceCertificate  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'home',
                }}
                />
        case 'DisputeHome' : 
                return <TripDisputeHome  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'home',
                }}
                />
        case 'DisputeTransactions' : 
                return <TripRaiseDispueTransactions  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'DisputeHome',
                }}
                />
        case 'CreateDispute' : 
                return <TripCreateRaiseDispute  setScreen = {setActiveScreen} setData={setData} data={data}
                info={{
                    backNavigation: 'DisputeTransactions',
                }}
                />
        
        default : return <InsuranceOptions  setData={setData} data={data} setScreen = {setActiveScreen} />
        }
      }

    return (
        <>
         <View>
             {renderSwitch()}
         </View>
        </>      
    )
}





